import cn from 'classnames'
import type {RefObject} from 'react'
import {COUNTRY_INFO} from '../constants'
import type {Country} from '../types'

interface CountrySelectorProps {
  country: Country | null
  hasError?: boolean
  errorRef?: RefObject<HTMLDivElement>
  onSelect: (country: Country) => void
}

export const CountrySelector = ({country, hasError, errorRef, onSelect}: CountrySelectorProps) => (
  <div>
    <div className="px-6 py-8">
      <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.06em] text-grey-450">Company's legal base</p>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        {COUNTRY_INFO.map(({id, flag, label}) => (
          <button
            key={id}
            onClick={() => onSelect(id)}
            className={cn(
              'flex flex-col items-center gap-[6px] rounded-lg border py-[14px] text-center transition-all',
              country === id
                ? 'border-green-dark bg-green-dark text-moss-white shadow-card'
                : 'border-grey-150 bg-grey-120 text-grey-550 hover:border-grey-300 hover:bg-moss-white hover:text-moss-black',
            )}
          >
            <span className="text-20">{flag}</span>
            <span className="text-12 font-semibold">{label}</span>
          </button>
        ))}
      </div>
      {hasError && (
        <div
          ref={errorRef}
          className="mt-3 flex items-center gap-2 rounded-lg border border-ui-red-150 bg-ui-red-150 px-4 py-3 text-13 text-ui-red-700"
        >
          Please select a country.
        </div>
      )}
    </div>
    <div className="mx-6 border-b border-grey-150" />
  </div>
)
